import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route,Routes} from 'react-router-dom';
import Home from './Components/Home';
import Applyloan from './Components/Applyloan';
import Banking from './Components/Banking';
import Insurance from './Components/Insurance';
import Wallet from './Components/Wallet';
import G2C from './Components/G2C';
import NewsandBlog from './Components/NewsandBlog';
import Contact from './Components/Contact';
import About from './Components/About';
import Terms from './Components/Terms';
import Privacy from './Components/Privacy';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <Routes>
      <Route path="/" element={<Home />} /> 
      <Route path="/apply-loan" element={<Applyloan />} /> 
      <Route path="/services" element={<Banking />} /> 
      <Route path="/insurance-services" element={<Insurance />} /> 
      <Route path="/wallet-services" element={<Wallet />} /> 
      <Route path="/g2c-services" element={<G2C />} /> 
     
      <Route path="/news-blogs" element={<NewsandBlog />} /> 
      <Route path="/contact" element={<Contact />} /> 
      <Route path="/about" element={<About />} />  
      <Route path="/terms" element={<Terms />} /> 
      <Route path="/privacy" element={<Privacy />} /> 
     
     
      
  </Routes>
</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
